webpackJsonp([231],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_ydui_dist_lib_rem_dialog__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_ydui_dist_lib_rem_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_ydui_dist_lib_rem_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppLayout__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_AppLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AppAddress__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_AppAddress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_AppAddress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_IndexApply__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_IndexApply___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_IndexApply__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_ydui_dist_lib_rem_infinitescroll__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_ydui_dist_lib_rem_infinitescroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_ydui_dist_lib_rem_infinitescroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_ydui_dist_lib_rem_cityselect__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_ydui_dist_lib_rem_cityselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_ydui_dist_lib_rem_cityselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_ydui_dist_lib_rem_checkbox__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_ydui_dist_lib_rem_checkbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_ydui_dist_lib_rem_checkbox__);


















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_3__components_AppLayout___default.a.name, __WEBPACK_IMPORTED_MODULE_3__components_AppLayout___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_4__components_AppAddress___default.a.name, __WEBPACK_IMPORTED_MODULE_4__components_AppAddress___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_5__components_IndexApply___default.a.name, __WEBPACK_IMPORTED_MODULE_5__components_IndexApply___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_6_vue_ydui_dist_lib_rem_infinitescroll__["InfiniteScroll"].name, __WEBPACK_IMPORTED_MODULE_6_vue_ydui_dist_lib_rem_infinitescroll__["InfiniteScroll"]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_7_vue_ydui_dist_lib_rem_cityselect__["CitySelect"].name, __WEBPACK_IMPORTED_MODULE_7_vue_ydui_dist_lib_rem_cityselect__["CitySelect"]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_8_vue_ydui_dist_lib_rem_checkbox__["CheckBox"].name, __WEBPACK_IMPORTED_MODULE_8_vue_ydui_dist_lib_rem_checkbox__["CheckBox"]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_8_vue_ydui_dist_lib_rem_checkbox__["CheckBoxGroup"].name, __WEBPACK_IMPORTED_MODULE_8_vue_ydui_dist_lib_rem_checkbox__["CheckBoxGroup"]);

/* 一些驾校报名入口 */
var someDrivingSchoolApply = function someDrivingSchoolApply(r) {
  return __webpack_require__.e/* require.ensure */(75).then((function () {
    return r(__webpack_require__(163));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

/* 云之驾App */
// 游客主页
var platformHomeApp = function platformHomeApp(r) {
  return __webpack_require__.e/* require.ensure */(22).then((function () {
    return r(__webpack_require__(124));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var platformHomeDetailsApp = function platformHomeDetailsApp(r) {
  return __webpack_require__.e/* require.ensure */(49).then((function () {
    return r(__webpack_require__(126));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var platformBodyCheckApp = function platformBodyCheckApp(r) {
  return __webpack_require__.e/* require.ensure */(186).then((function () {
    return r(__webpack_require__(125));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var platformRuleApp = function platformRuleApp(r) {
  return __webpack_require__.e/* require.ensure */(185).then((function () {
    return r(__webpack_require__(127));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var platformOnlineApplyApp = function platformOnlineApplyApp(r) {
  return __webpack_require__.e/* require.ensure */(60).then((function () {
    return r(__webpack_require__(128));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var platformResultPayZFBApp = function platformResultPayZFBApp(r) {
  return __webpack_require__.e/* require.ensure */(78).then((function () {
    return r(__webpack_require__(129));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var platformWantKnowApp = function platformWantKnowApp(r) {
  return __webpack_require__.e/* require.ensure */(101).then((function () {
    return r(__webpack_require__(131));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var platformRecruitStudentApp = function platformRecruitStudentApp(r) {
  return __webpack_require__.e/* require.ensure */(132).then((function () {
    return r(__webpack_require__(130));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var platformWarningCoachApp = function platformWarningCoachApp(r) {
  return __webpack_require__.e/* require.ensure */(37).then((function () {
    return r(__webpack_require__(132));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// banner广告
var platformBannerApp = function platformBannerApp(r) {
  return __webpack_require__.e/* require.ensure */(120).then((function () {
    return r(__webpack_require__(123));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

/* 车小爱App */
// 点赞教练
var loveUpCoachApp = function loveUpCoachApp(r) {
  return __webpack_require__.e/* require.ensure */(39).then((function () {
    return r(__webpack_require__(54));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 注册提示
var loveRegisterApp = function loveRegisterApp(r) {
  return __webpack_require__.e/* require.ensure */(83).then((function () {
    return r(__webpack_require__(52));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveRegisterProtocolApp = function loveRegisterProtocolApp(r) {
  return __webpack_require__.e/* require.ensure */(226).then((function () {
    return r(__webpack_require__(53));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 我的小爱币
var loveMyLoveCoinApp = function loveMyLoveCoinApp(r) {
  return __webpack_require__.e/* require.ensure */(63).then((function () {
    return r(__webpack_require__(45));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveMyLoveCoinHistoryApp = function loveMyLoveCoinHistoryApp(r) {
  return __webpack_require__.e/* require.ensure */(53).then((function () {
    return r(__webpack_require__(46));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveMyLoveCoinRuleApp = function loveMyLoveCoinRuleApp(r) {
  return __webpack_require__.e/* require.ensure */(227).then((function () {
    return r(__webpack_require__(47));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 游客主页
var loveHomeApp = function loveHomeApp(r) {
  return __webpack_require__.e/* require.ensure */(23).then((function () {
    return r(__webpack_require__(39));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveHomeDetailsApp = function loveHomeDetailsApp(r) {
  return __webpack_require__.e/* require.ensure */(54).then((function () {
    return r(__webpack_require__(41));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveBodyCheckApp = function loveBodyCheckApp(r) {
  return __webpack_require__.e/* require.ensure */(229).then((function () {
    return r(__webpack_require__(40));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveRuleApp = function loveRuleApp(r) {
  return __webpack_require__.e/* require.ensure */(228).then((function () {
    return r(__webpack_require__(42));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var loveOnlineApplyApp = function loveOnlineApplyApp(r) {
  return __webpack_require__.e/* require.ensure */(61).then((function () {
    return r(__webpack_require__(49));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveApplyPayApp = function loveApplyPayApp(r) {
  return __webpack_require__.e/* require.ensure */(52).then((function () {
    return r(__webpack_require__(50));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveResultPayZFBApp = function loveResultPayZFBApp(r) {
  return __webpack_require__.e/* require.ensure */(84).then((function () {
    return r(__webpack_require__(51));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveWantKnowApp = function loveWantKnowApp(r) {
  return __webpack_require__.e/* require.ensure */(104).then((function () {
    return r(__webpack_require__(55));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// banner广告
var loveBannerApp = function loveBannerApp(r) {
  return __webpack_require__.e/* require.ensure */(137).then((function () {
    return r(__webpack_require__(38));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 更多
var loveMorePageApp = function loveMorePageApp(r) {
  return __webpack_require__.e/* require.ensure */(136).then((function () {
    return r(__webpack_require__(43));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 教学区域
var loveTeachAreaApp = function loveTeachAreaApp(r) {
  return __webpack_require__.e/* require.ensure */(40).then((function () {
    return r(__webpack_require__(44));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 我的训练
var loveMyTrainApp = function loveMyTrainApp(r) {
  return __webpack_require__.e/* require.ensure */(62).then((function () {
    return r(__webpack_require__(48));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

/* 车小爱内容 */
// 招生
var loveRecruitStudent = function loveRecruitStudent(r) {
  return __webpack_require__.e/* require.ensure */(121).then((function () {
    return r(__webpack_require__(82));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 产品列表
var loveProductList = function loveProductList(r) {
  return __webpack_require__.e/* require.ensure */(29).then((function () {
    return r(__webpack_require__(68));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 产品详情
var loveProductDetails = function loveProductDetails(r) {
  return __webpack_require__.e/* require.ensure */(51).then((function () {
    return r(__webpack_require__(74));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 练车技巧
var lovePracticeSkills = function lovePracticeSkills(r) {
  return __webpack_require__.e/* require.ensure */(223).then((function () {
    return r(__webpack_require__(67));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 推广查询
var lovePromotionQuery = function lovePromotionQuery(r) {
  return __webpack_require__.e/* require.ensure */(103).then((function () {
    return r(__webpack_require__(78));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 客户留资
var lovePromotionRegister = function lovePromotionRegister(r) {
  return __webpack_require__.e/* require.ensure */(80).then((function () {
    return r(__webpack_require__(79));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 报名指南
var loveGuide = function loveGuide(r) {
  return __webpack_require__.e/* require.ensure */(218).then((function () {
    return r(__webpack_require__(73));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 体检事项
var loveBodyCheck = function loveBodyCheck(r) {
  return __webpack_require__.e/* require.ensure */(222).then((function () {
    return r(__webpack_require__(69));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 体检详情
var loveBodyQuery = function loveBodyQuery(r) {
  return __webpack_require__.e/* require.ensure */(221).then((function () {
    return r(__webpack_require__(70));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 体检单过期
var loveHealthList = function loveHealthList(r) {
  return __webpack_require__.e/* require.ensure */(219).then((function () {
    return r(__webpack_require__(72));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 体检地址
var loveHealthAddress = function loveHealthAddress(r) {
  return __webpack_require__.e/* require.ensure */(220).then((function () {
    return r(__webpack_require__(71));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 驾考新规
var loveRule = function loveRule(r) {
  return __webpack_require__.e/* require.ensure */(217).then((function () {
    return r(__webpack_require__(75));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 2017新交规扣分标准
var loveNewRule = function loveNewRule(r) {
  return __webpack_require__.e/* require.ensure */(215).then((function () {
    return r(__webpack_require__(77));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 酒驾新规
var loveDrunkDriving = function loveDrunkDriving(r) {
  return __webpack_require__.e/* require.ensure */(216).then((function () {
    return r(__webpack_require__(76));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 报名
var loveOnlineApply = function loveOnlineApply(r) {
  return __webpack_require__.e/* require.ensure */(82).then((function () {
    return r(__webpack_require__(65));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 公众号支付完成后跳转页
var loveResultPayOfficial = function loveResultPayOfficial(r) {
  return __webpack_require__.e/* require.ensure */(81).then((function () {
    return r(__webpack_require__(66));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 了解
var loveWantKnow = function loveWantKnow(r) {
  return __webpack_require__.e/* require.ensure */(102).then((function () {
    return r(__webpack_require__(121));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 报名查询
var loveApplyQuery = function loveApplyQuery(r) {
  return __webpack_require__.e/* require.ensure */(38).then((function () {
    return r(__webpack_require__(60));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 学车流程
var loveNotice = function loveNotice(r) {
  return __webpack_require__.e/* require.ensure */(225).then((function () {
    return r(__webpack_require__(62));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 报名证件
var loveNoticePapers = function loveNoticePapers(r) {
  return __webpack_require__.e/* require.ensure */(134).then((function () {
    return r(__webpack_require__(64));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 体检流程
var loveNoticeFlow = function loveNoticeFlow(r) {
  return __webpack_require__.e/* require.ensure */(224).then((function () {
    return r(__webpack_require__(63));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 关于车小爱
var loveAbout = function loveAbout(r) {
  return __webpack_require__.e/* require.ensure */(125).then((function () {
    return r(__webpack_require__(56));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 公司简介
var loveAboutUs = function loveAboutUs(r) {
  return __webpack_require__.e/* require.ensure */(123).then((function () {
    return r(__webpack_require__(58));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 联系我们
var loveAboutAddress = function loveAboutAddress(r) {
  return __webpack_require__.e/* require.ensure */(124).then((function () {
    return r(__webpack_require__(57));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 最新活动
var loveActivity = function loveActivity(r) {
  return __webpack_require__.e/* require.ensure */(122).then((function () {
    return r(__webpack_require__(59));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 下载App
var loveDownLoadApp = function loveDownLoadApp(r) {
  return __webpack_require__.e/* require.ensure */(135).then((function () {
    return r(__webpack_require__(61));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 微校区
var loveSmallSchool = function loveSmallSchool(r) {
  return __webpack_require__.e/* require.ensure */(16).then((function () {
    return r(__webpack_require__(83));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 微相册
var lovePhoto = function lovePhoto(r) {
  return __webpack_require__.e/* require.ensure */(212).then((function () {
    return r(__webpack_require__(88));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 微相册详情
var lovePhotoDetail = function lovePhotoDetail(r) {
  return __webpack_require__.e/* require.ensure */(211).then((function () {
    return r(__webpack_require__(89));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 校区位置
var loveSchoolAddress = function loveSchoolAddress(r) {
  return __webpack_require__.e/* require.ensure */(210).then((function () {
    return r(__webpack_require__(90));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 校区位置详情
var loveSchoolAddressDetail = function loveSchoolAddressDetail(r) {
  return __webpack_require__.e/* require.ensure */(209).then((function () {
    return r(__webpack_require__(91));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 我的微校区
var loveMy = function loveMy(r) {
  return __webpack_require__.e/* require.ensure */(118).then((function () {
    return r(__webpack_require__(86));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 驾校航拍
var loveAerialPhoto = function loveAerialPhoto(r) {
  return __webpack_require__.e/* require.ensure */(214).then((function () {
    return r(__webpack_require__(84));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 驾校航拍详情
var loveAerialPhotoDetail = function loveAerialPhotoDetail(r) {
  return __webpack_require__.e/* require.ensure */(213).then((function () {
    return r(__webpack_require__(85));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 最新热点
var loveNewActive = function loveNewActive(r) {
  return __webpack_require__.e/* require.ensure */(133).then((function () {
    return r(__webpack_require__(87));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 车小爱理论题库
var loveStudyScope = function loveStudyScope(r) {
  return __webpack_require__.e/* require.ensure */(111).then((function () {
    return r(__webpack_require__(116));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 考规
var loveStudyRule1 = function loveStudyRule1(r) {
  return __webpack_require__.e/* require.ensure */(190).then((function () {
    return r(__webpack_require__(117));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveStudyRule2 = function loveStudyRule2(r) {
  return __webpack_require__.e/* require.ensure */(189).then((function () {
    return r(__webpack_require__(118));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveStudyRule3 = function loveStudyRule3(r) {
  return __webpack_require__.e/* require.ensure */(188).then((function () {
    return r(__webpack_require__(119));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveStudyRule4 = function loveStudyRule4(r) {
  return __webpack_require__.e/* require.ensure */(187).then((function () {
    return r(__webpack_require__(120));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 车小爱答题技巧
var loveAnswer = function loveAnswer(r) {
  return __webpack_require__.e/* require.ensure */(200).then((function () {
    return r(__webpack_require__(100));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveAnswerTip1 = function loveAnswerTip1(r) {
  return __webpack_require__.e/* require.ensure */(208).then((function () {
    return r(__webpack_require__(92));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveAnswerTip2 = function loveAnswerTip2(r) {
  return __webpack_require__.e/* require.ensure */(207).then((function () {
    return r(__webpack_require__(93));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveAnswerTip3 = function loveAnswerTip3(r) {
  return __webpack_require__.e/* require.ensure */(206).then((function () {
    return r(__webpack_require__(94));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveAnswerTip4 = function loveAnswerTip4(r) {
  return __webpack_require__.e/* require.ensure */(205).then((function () {
    return r(__webpack_require__(95));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveAnswerTip5 = function loveAnswerTip5(r) {
  return __webpack_require__.e/* require.ensure */(204).then((function () {
    return r(__webpack_require__(96));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveAnswerTip6 = function loveAnswerTip6(r) {
  return __webpack_require__.e/* require.ensure */(203).then((function () {
    return r(__webpack_require__(97));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveAnswerTip7 = function loveAnswerTip7(r) {
  return __webpack_require__.e/* require.ensure */(202).then((function () {
    return r(__webpack_require__(98));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveAnswerTip8 = function loveAnswerTip8(r) {
  return __webpack_require__.e/* require.ensure */(201).then((function () {
    return r(__webpack_require__(99));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 车小爱经验技巧
var loveExperience2 = function loveExperience2(r) {
  return __webpack_require__.e/* require.ensure */(192).then((function () {
    return r(__webpack_require__(111));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveExperience2Tip1 = function loveExperience2Tip1(r) {
  return __webpack_require__.e/* require.ensure */(6).then((function () {
    return r(__webpack_require__(102));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveExperience2Tip2 = function loveExperience2Tip2(r) {
  return __webpack_require__.e/* require.ensure */(5).then((function () {
    return r(__webpack_require__(103));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveExperience2Tip3 = function loveExperience2Tip3(r) {
  return __webpack_require__.e/* require.ensure */(4).then((function () {
    return r(__webpack_require__(104));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveExperience2Tip4 = function loveExperience2Tip4(r) {
  return __webpack_require__.e/* require.ensure */(198).then((function () {
    return r(__webpack_require__(105));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveExperience2Tip5 = function loveExperience2Tip5(r) {
  return __webpack_require__.e/* require.ensure */(197).then((function () {
    return r(__webpack_require__(106));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveExperience2Tip6 = function loveExperience2Tip6(r) {
  return __webpack_require__.e/* require.ensure */(196).then((function () {
    return r(__webpack_require__(107));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveExperience2Tip7 = function loveExperience2Tip7(r) {
  return __webpack_require__.e/* require.ensure */(195).then((function () {
    return r(__webpack_require__(108));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveExperience2Tip8 = function loveExperience2Tip8(r) {
  return __webpack_require__.e/* require.ensure */(194).then((function () {
    return r(__webpack_require__(109));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveExperience2Tip9 = function loveExperience2Tip9(r) {
  return __webpack_require__.e/* require.ensure */(193).then((function () {
    return r(__webpack_require__(110));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var loveExperience3 = function loveExperience3(r) {
  return __webpack_require__.e/* require.ensure */(191).then((function () {
    return r(__webpack_require__(115));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveExperience3Tip1 = function loveExperience3Tip1(r) {
  return __webpack_require__.e/* require.ensure */(6).then((function () {
    return r(__webpack_require__(112));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveExperience3Tip2 = function loveExperience3Tip2(r) {
  return __webpack_require__.e/* require.ensure */(5).then((function () {
    return r(__webpack_require__(113));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var loveExperience3Tip3 = function loveExperience3Tip3(r) {
  return __webpack_require__.e/* require.ensure */(4).then((function () {
    return r(__webpack_require__(114));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var loveBeforeExam = function loveBeforeExam(r) {
  return __webpack_require__.e/* require.ensure */(199).then((function () {
    return r(__webpack_require__(101));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 题库
// 在线练习
var loveExercise = function loveExercise(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__(80));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 模拟考试
var loveSimulate = function loveSimulate(r) {
  return __webpack_require__.e/* require.ensure */(50).then((function () {
    return r(__webpack_require__(81));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
/* 消息 */
var m0001 = function m0001(r) {
  return __webpack_require__.e/* require.ensure */(79).then((function () {
    return r(__webpack_require__(122));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

/* 荣安App */
// 驾校信息
var schoolInfoApp = function schoolInfoApp(r) {
  return __webpack_require__.e/* require.ensure */(230).then((function () {
    return r(__webpack_require__(146));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 引导页
var guidePicApp = function guidePicApp(r) {
  return __webpack_require__.e/* require.ensure */(117).then((function () {
    return r(__webpack_require__(139));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 游客首页
var homeApp = function homeApp(r) {
  return __webpack_require__.e/* require.ensure */(35).then((function () {
    return r(__webpack_require__(142));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 游客驾校详情
var homeDetailsApp = function homeDetailsApp(r) {
  return __webpack_require__.e/* require.ensure */(48).then((function () {
    return r(__webpack_require__(141));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var bodyCheckApp = function bodyCheckApp(r) {
  return __webpack_require__.e/* require.ensure */(183).then((function () {
    return r(__webpack_require__(140));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var ruleApp = function ruleApp(r) {
  return __webpack_require__.e/* require.ensure */(182).then((function () {
    return r(__webpack_require__(143));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 游客报名
var onlineApplyApp = function onlineApplyApp(r) {
  return __webpack_require__.e/* require.ensure */(59).then((function () {
    return r(__webpack_require__(144));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 订单支付结果
var resultPayZFBApp = function resultPayZFBApp(r) {
  return __webpack_require__.e/* require.ensure */(76).then((function () {
    return r(__webpack_require__(145));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 游客了解
var wantKnowApp = function wantKnowApp(r) {
  return __webpack_require__.e/* require.ensure */(99).then((function () {
    return r(__webpack_require__(149));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 报名查询
var applyQueryApp = function applyQueryApp(r) {
  return __webpack_require__.e/* require.ensure */(36).then((function () {
    return r(__webpack_require__(133));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 理论课预约
var theoryOrder = function theoryOrder(r) {
  return __webpack_require__.e/* require.ensure */(7).then((function () {
    return r(__webpack_require__(148));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 理论课预约班车
var busOrder = function busOrder(r) {
  return __webpack_require__.e/* require.ensure */(47).then((function () {
    return r(__webpack_require__(147));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 考场信息
var examinationMessageApp = function examinationMessageApp(r) {
  return __webpack_require__.e/* require.ensure */(28).then((function () {
    return r(__webpack_require__(138));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 投诉
var complaintApp = function complaintApp(r) {
  return __webpack_require__.e/* require.ensure */(100).then((function () {
    return r(__webpack_require__(137));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var feedBackApp = function feedBackApp(r) {
  return __webpack_require__.e/* require.ensure */(77).then((function () {
    return r(__webpack_require__(136));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 原生首页banner
var bannerApp = function bannerApp(r) {
  return __webpack_require__.e/* require.ensure */(119).then((function () {
    return r(__webpack_require__(135));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 全流程分享
var allProcessShareApp = function allProcessShareApp(r) {
  return __webpack_require__.e/* require.ensure */(184).then((function () {
    return r(__webpack_require__(134));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
/* 荣安教练app */
// 招生主页
var recruitStudent = function recruitStudent(r) {
  return __webpack_require__.e/* require.ensure */(130).then((function () {
    return r(__webpack_require__(156));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 学员列表
var studentListApp = function studentListApp(r) {
  return __webpack_require__.e/* require.ensure */(8).then((function () {
    return r(__webpack_require__(162));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var feeList = function feeList(r) {
  return __webpack_require__.e/* require.ensure */(98).then((function () {
    return r(__webpack_require__(161));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var studentDetailApp = function studentDetailApp(r) {
  return __webpack_require__.e/* require.ensure */(9).then((function () {
    return r(__webpack_require__(160));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 我的绩效
var myPerformanceApp = function myPerformanceApp(r) {
  return __webpack_require__.e/* require.ensure */(12).then((function () {
    return r(__webpack_require__(151));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var myPerformChooseModelApp = function myPerformChooseModelApp(r) {
  return __webpack_require__.e/* require.ensure */(131).then((function () {
    return r(__webpack_require__(152));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 预约训练
var orderTrainApp = function orderTrainApp(r) {
  return __webpack_require__.e/* require.ensure */(34).then((function () {
    return r(__webpack_require__(153));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 预约训练选择时段
var orderTrainChooseDateApp = function orderTrainChooseDateApp(r) {
  return __webpack_require__.e/* require.ensure */(27).then((function () {
    return r(__webpack_require__(155));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 预约训练选择教练
var orderCoachChoose = function orderCoachChoose(r) {
  return __webpack_require__.e/* require.ensure */(33).then((function () {
    return r(__webpack_require__(154));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 设备故障码列表
var facilityFaultApp = function facilityFaultApp(r) {
  return __webpack_require__.e/* require.ensure */(181).then((function () {
    return r(__webpack_require__(150));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 学员评估
var studentAssessApp = function studentAssessApp(r) {
  return __webpack_require__.e/* require.ensure */(43).then((function () {
    return r(__webpack_require__(159));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 能力评估
var competentAssessApp = function competentAssessApp(r) {
  return __webpack_require__.e/* require.ensure */(26).then((function () {
    return r(__webpack_require__(158));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 消息分享
var shareStudentApp = function shareStudentApp(r) {
  return __webpack_require__.e/* require.ensure */(180).then((function () {
    return r(__webpack_require__(157));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
/* 荣安公众号内容 */
// 404 NOT FOUND
var notFound = function notFound(r) {
  return __webpack_require__.e/* require.ensure */(175).then((function () {
    return r(__webpack_require__(171));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 视频学习
var videoParts = function videoParts(r) {
  return __webpack_require__.e/* require.ensure */(147).then((function () {
    return r(__webpack_require__(254));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var videoLessons = function videoLessons(r) {
  return __webpack_require__.e/* require.ensure */(67).then((function () {
    return r(__webpack_require__(253));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var videoPlay = function videoPlay(r) {
  return __webpack_require__.e/* require.ensure */(146).then((function () {
    return r(__webpack_require__(255));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 考场
// 考场首页
var exam = function exam(r) {
  return __webpack_require__.e/* require.ensure */(42).then((function () {
    return r(__webpack_require__(188));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 教练身份认证
var coachIdentify = function coachIdentify(r) {
  return __webpack_require__.e/* require.ensure */(87).then((function () {
    return r(__webpack_require__(184));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 学员身份认证
var studentIdentify = function studentIdentify(r) {
  return __webpack_require__.e/* require.ensure */(85).then((function () {
    return r(__webpack_require__(198));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 管理员身份认证
var managerIdentify = function managerIdentify(r) {
  return __webpack_require__.e/* require.ensure */(93).then((function () {
    return r(__webpack_require__(189));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 教练首页
var coachMain = function coachMain(r) {
  return __webpack_require__.e/* require.ensure */(20).then((function () {
    return r(__webpack_require__(185));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 管理员首页
var managerMain = function managerMain(r) {
  return __webpack_require__.e/* require.ensure */(41).then((function () {
    return r(__webpack_require__(190));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 学员首页
var studentMain = function studentMain(r) {
  return __webpack_require__.e/* require.ensure */(46).then((function () {
    return r(__webpack_require__(199));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 订单管理
var orderList = function orderList(r) {
  return __webpack_require__.e/* require.ensure */(11).then((function () {
    return r(__webpack_require__(196));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 订单支付确认
var orderConfirm = function orderConfirm(r) {
  return __webpack_require__.e/* require.ensure */(55).then((function () {
    return r(__webpack_require__(195));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
//  支付成功
var orderPayResult = function orderPayResult(r) {
  return __webpack_require__.e/* require.ensure */(127).then((function () {
    return r(__webpack_require__(197));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 车辆管理
//  新车注册
var vehicelRegister = function vehicelRegister(r) {
  return __webpack_require__.e/* require.ensure */(86).then((function () {
    return r(__webpack_require__(187));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
//  车辆查询
var vehicelList = function vehicelList(r) {
  return __webpack_require__.e/* require.ensure */(56).then((function () {
    return r(__webpack_require__(186));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 账户中心
var accountCenter = function accountCenter(r) {
  return __webpack_require__.e/* require.ensure */(73).then((function () {
    return r(__webpack_require__(172));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 账户明细
var accountDetail = function accountDetail(r) {
  return __webpack_require__.e/* require.ensure */(25).then((function () {
    return r(__webpack_require__(173));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 教练充值
var personRecharge = function personRecharge(r) {
  return __webpack_require__.e/* require.ensure */(97).then((function () {
    return r(__webpack_require__(174));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 教练车充值
var vehicleRecharge = function vehicleRecharge(r) {
  return __webpack_require__.e/* require.ensure */(96).then((function () {
    return r(__webpack_require__(176));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
//  充值成功
var rechargingResult = function rechargingResult(r) {
  return __webpack_require__.e/* require.ensure */(129).then((function () {
    return r(__webpack_require__(175));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 预约
// 模式选择
var modelSelection = function modelSelection(r) {
  return __webpack_require__.e/* require.ensure */(94).then((function () {
    return r(__webpack_require__(180));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 课程选择
var lessionSelection = function lessionSelection(r) {
  return __webpack_require__.e/* require.ensure */(95).then((function () {
    return r(__webpack_require__(179));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 时间选择
var timeSelection = function timeSelection(r) {
  return __webpack_require__.e/* require.ensure */(57).then((function () {
    return r(__webpack_require__(182));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 圈数选择
var turnsSelection = function turnsSelection(r) {
  return __webpack_require__.e/* require.ensure */(174).then((function () {
    return r(__webpack_require__(183));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 选择确认
var selectionConfirm = function selectionConfirm(r) {
  return __webpack_require__.e/* require.ensure */(58).then((function () {
    return r(__webpack_require__(181));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 结果
var bookingResult = function bookingResult(r) {
  return __webpack_require__.e/* require.ensure */(128).then((function () {
    return r(__webpack_require__(178));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 预约列表
var bookingList = function bookingList(r) {
  return __webpack_require__.e/* require.ensure */(21).then((function () {
    return r(__webpack_require__(177));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 管理员
// 管理员预约查看
var recordList = function recordList(r) {
  return __webpack_require__.e/* require.ensure */(19).then((function () {
    return r(__webpack_require__(192));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 管理员工作记录
var workList = function workList(r) {
  return __webpack_require__.e/* require.ensure */(18).then((function () {
    return r(__webpack_require__(194));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 管理员扫描签到--车辆确认
var vehicelConfirm = function vehicelConfirm(r) {
  return __webpack_require__.e/* require.ensure */(71).then((function () {
    return r(__webpack_require__(193));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 管理员扫描签退--超时免单
var overTimeOrder = function overTimeOrder(r) {
  return __webpack_require__.e/* require.ensure */(72).then((function () {
    return r(__webpack_require__(191));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 首页
var home = function home(r) {
  return __webpack_require__.e/* require.ensure */(31).then((function () {
    return r(__webpack_require__(202));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 轮播图
var bannerDetail = function bannerDetail(r) {
  return __webpack_require__.e/* require.ensure */(116).then((function () {
    return r(__webpack_require__(165));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 驾校详情
var homeDetails = function homeDetails(r) {
  return __webpack_require__.e/* require.ensure */(45).then((function () {
    return r(__webpack_require__(201));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 我的 (个人中心首页)
var ucenter = function ucenter(r) {
  return __webpack_require__.e/* require.ensure */(109).then((function () {
    return r(__webpack_require__(252));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 报名
var stutentSign = function stutentSign(r) {
  return __webpack_require__.e/* require.ensure */(112).then((function () {
    return r(__webpack_require__(203));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 在线报名查询
var applyQuery = function applyQuery(r) {
  return __webpack_require__.e/* require.ensure */(32).then((function () {
    return r(__webpack_require__(164));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 报名指南
var guide = function guide(r) {
  return __webpack_require__.e/* require.ensure */(173).then((function () {
    return r(__webpack_require__(200));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 注册
var coachRegister = function coachRegister(r) {
  return __webpack_require__.e/* require.ensure */(74).then((function () {
    return r(__webpack_require__(170));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 推广查询
var promotionQuery = function promotionQuery(r) {
  return __webpack_require__.e/* require.ensure */(91).then((function () {
    return r(__webpack_require__(209));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 客户留资
var promotionRegister = function promotionRegister(r) {
  return __webpack_require__.e/* require.ensure */(68).then((function () {
    return r(__webpack_require__(210));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 我的推荐
var myRecommend = function myRecommend(r) {
  return __webpack_require__.e/* require.ensure */(92).then((function () {
    return r(__webpack_require__(204));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 微校区
var smallSchool = function smallSchool(r) {
  return __webpack_require__.e/* require.ensure */(30).then((function () {
    return r(__webpack_require__(217));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 在线报名
var onlineApply = function onlineApply(r) {
  return __webpack_require__.e/* require.ensure */(70).then((function () {
    return r(__webpack_require__(206));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 支付成功后查询页
var resultPayOfficial = function resultPayOfficial(r) {
  return __webpack_require__.e/* require.ensure */(69).then((function () {
    return r(__webpack_require__(207));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 支付详情
var applyDetails = function applyDetails(r) {
  return __webpack_require__.e/* require.ensure */(126).then((function () {
    return r(__webpack_require__(205));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 我想了解
var wantKnow = function wantKnow(r) {
  return __webpack_require__.e/* require.ensure */(90).then((function () {
    return r(__webpack_require__(256));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 体检事项
var bodyCheck = function bodyCheck(r) {
  return __webpack_require__.e/* require.ensure */(176).then((function () {
    return r(__webpack_require__(169));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 体检详情
var bodyQuery = function bodyQuery(r) {
  return __webpack_require__.e/* require.ensure */(179).then((function () {
    return r(__webpack_require__(166));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 体检单过期
var healthList = function healthList(r) {
  return __webpack_require__.e/* require.ensure */(177).then((function () {
    return r(__webpack_require__(168));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 体检地址
var healthAddress = function healthAddress(r) {
  return __webpack_require__.e/* require.ensure */(178).then((function () {
    return r(__webpack_require__(167));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 驾考新规
var rule = function rule(r) {
  return __webpack_require__.e/* require.ensure */(171).then((function () {
    return r(__webpack_require__(215));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 2017新交规扣分标准
var newRule = function newRule(r) {
  return __webpack_require__.e/* require.ensure */(170).then((function () {
    return r(__webpack_require__(216));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 酒驾新规
var drunkDriving = function drunkDriving(r) {
  return __webpack_require__.e/* require.ensure */(172).then((function () {
    return r(__webpack_require__(214));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 理论题库
var studyScope = function studyScope(r) {
  return __webpack_require__.e/* require.ensure */(110).then((function () {
    return r(__webpack_require__(242));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 考规
var studyRule1 = function studyRule1(r) {
  return __webpack_require__.e/* require.ensure */(151).then((function () {
    return r(__webpack_require__(243));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var studyRule2 = function studyRule2(r) {
  return __webpack_require__.e/* require.ensure */(150).then((function () {
    return r(__webpack_require__(244));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var studyRule3 = function studyRule3(r) {
  return __webpack_require__.e/* require.ensure */(149).then((function () {
    return r(__webpack_require__(245));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var studyRule4 = function studyRule4(r) {
  return __webpack_require__.e/* require.ensure */(148).then((function () {
    return r(__webpack_require__(246));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 答题技巧
var answer = function answer(r) {
  return __webpack_require__.e/* require.ensure */(161).then((function () {
    return r(__webpack_require__(226));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var answerTip1 = function answerTip1(r) {
  return __webpack_require__.e/* require.ensure */(169).then((function () {
    return r(__webpack_require__(218));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var answerTip2 = function answerTip2(r) {
  return __webpack_require__.e/* require.ensure */(168).then((function () {
    return r(__webpack_require__(219));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var answerTip3 = function answerTip3(r) {
  return __webpack_require__.e/* require.ensure */(167).then((function () {
    return r(__webpack_require__(220));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var answerTip4 = function answerTip4(r) {
  return __webpack_require__.e/* require.ensure */(166).then((function () {
    return r(__webpack_require__(221));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var answerTip5 = function answerTip5(r) {
  return __webpack_require__.e/* require.ensure */(165).then((function () {
    return r(__webpack_require__(222));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var answerTip6 = function answerTip6(r) {
  return __webpack_require__.e/* require.ensure */(164).then((function () {
    return r(__webpack_require__(223));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var answerTip7 = function answerTip7(r) {
  return __webpack_require__.e/* require.ensure */(163).then((function () {
    return r(__webpack_require__(224));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var answerTip8 = function answerTip8(r) {
  return __webpack_require__.e/* require.ensure */(162).then((function () {
    return r(__webpack_require__(225));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 经验技巧
var experience2 = function experience2(r) {
  return __webpack_require__.e/* require.ensure */(153).then((function () {
    return r(__webpack_require__(237));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var experience2Tip1 = function experience2Tip1(r) {
  return __webpack_require__.e/* require.ensure */(3).then((function () {
    return r(__webpack_require__(228));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var experience2Tip2 = function experience2Tip2(r) {
  return __webpack_require__.e/* require.ensure */(2).then((function () {
    return r(__webpack_require__(229));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var experience2Tip3 = function experience2Tip3(r) {
  return __webpack_require__.e/* require.ensure */(1).then((function () {
    return r(__webpack_require__(230));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var experience2Tip4 = function experience2Tip4(r) {
  return __webpack_require__.e/* require.ensure */(159).then((function () {
    return r(__webpack_require__(231));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var experience2Tip5 = function experience2Tip5(r) {
  return __webpack_require__.e/* require.ensure */(158).then((function () {
    return r(__webpack_require__(232));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var experience2Tip6 = function experience2Tip6(r) {
  return __webpack_require__.e/* require.ensure */(157).then((function () {
    return r(__webpack_require__(233));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var experience2Tip7 = function experience2Tip7(r) {
  return __webpack_require__.e/* require.ensure */(156).then((function () {
    return r(__webpack_require__(234));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var experience2Tip8 = function experience2Tip8(r) {
  return __webpack_require__.e/* require.ensure */(155).then((function () {
    return r(__webpack_require__(235));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var experience2Tip9 = function experience2Tip9(r) {
  return __webpack_require__.e/* require.ensure */(154).then((function () {
    return r(__webpack_require__(236));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var experience3 = function experience3(r) {
  return __webpack_require__.e/* require.ensure */(152).then((function () {
    return r(__webpack_require__(241));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var experience3Tip1 = function experience3Tip1(r) {
  return __webpack_require__.e/* require.ensure */(3).then((function () {
    return r(__webpack_require__(238));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var experience3Tip2 = function experience3Tip2(r) {
  return __webpack_require__.e/* require.ensure */(2).then((function () {
    return r(__webpack_require__(239));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var experience3Tip3 = function experience3Tip3(r) {
  return __webpack_require__.e/* require.ensure */(1).then((function () {
    return r(__webpack_require__(240));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var beforeExam = function beforeExam(r) {
  return __webpack_require__.e/* require.ensure */(160).then((function () {
    return r(__webpack_require__(227));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 个人信息
var personalDetails = function personalDetails(r) {
  return __webpack_require__.e/* require.ensure */(115).then((function () {
    return r(__webpack_require__(208));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 题库
var questionBank = function questionBank(r) {
  return __webpack_require__.e/* require.ensure */(113).then((function () {
    return r(__webpack_require__(211));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 在线练习
var exercise = function exercise(r) {
  return __webpack_require__.e/* require.ensure */(0).then((function () {
    return r(__webpack_require__(212));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 模拟考试
var simulate = function simulate(r) {
  return __webpack_require__.e/* require.ensure */(44).then((function () {
    return r(__webpack_require__(213));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 科目二训练和单放日志
var training2Log = function training2Log(r) {
  return __webpack_require__.e/* require.ensure */(14).then((function () {
    return r(__webpack_require__(248));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 科目二考核日志
var inspection2Log = function inspection2Log(r) {
  return __webpack_require__.e/* require.ensure */(15).then((function () {
    return r(__webpack_require__(247));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 科目三训练日志
var training3Log = function training3Log(r) {
  return __webpack_require__.e/* require.ensure */(13).then((function () {
    return r(__webpack_require__(251));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 科目三考核日志
var inspection3Log = function inspection3Log(r) {
  return __webpack_require__.e/* require.ensure */(17).then((function () {
    return r(__webpack_require__(249));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 科目三同车互动
var sameCarInteractionLog = function sameCarInteractionLog(r) {
  return __webpack_require__.e/* require.ensure */(24).then((function () {
    return r(__webpack_require__(250));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

/** 中驾微信公众号 start */
// 中驾介绍
var aboutZhongJia = function aboutZhongJia(r) {
  return __webpack_require__.e/* require.ensure */(114).then((function () {
    return r(__webpack_require__(257));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var partMenu = function partMenu(r) {
  return __webpack_require__.e/* require.ensure */(141).then((function () {
    return r(__webpack_require__(268));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var zhongjiaExamPart1 = function zhongjiaExamPart1(r) {
  return __webpack_require__.e/* require.ensure */(105).then((function () {
    return r(__webpack_require__(261));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var zhongjiaExamPart2 = function zhongjiaExamPart2(r) {
  return __webpack_require__.e/* require.ensure */(106).then((function () {
    return r(__webpack_require__(262));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var zhongjiaExamPart3 = function zhongjiaExamPart3(r) {
  return __webpack_require__.e/* require.ensure */(107).then((function () {
    return r(__webpack_require__(263));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var zhongjiaExamPart4 = function zhongjiaExamPart4(r) {
  return __webpack_require__.e/* require.ensure */(108).then((function () {
    return r(__webpack_require__(264));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

// 产品列表
var zhongjiaProduct = function zhongjiaProduct(r) {
  return __webpack_require__.e/* require.ensure */(10).then((function () {
    return r(__webpack_require__(269));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 报名指南
var zhongjiaGuide = function zhongjiaGuide(r) {
  return __webpack_require__.e/* require.ensure */(142).then((function () {
    return r(__webpack_require__(265));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 体检事项
var zhongjiaBodyCheck = function zhongjiaBodyCheck(r) {
  return __webpack_require__.e/* require.ensure */(143).then((function () {
    return r(__webpack_require__(260));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 色弱是否可以学车
var zhongjiaBodyQuery = function zhongjiaBodyQuery(r) {
  return __webpack_require__.e/* require.ensure */(145).then((function () {
    return r(__webpack_require__(258));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 体检单过期
var zhongjiaHealthList = function zhongjiaHealthList(r) {
  return __webpack_require__.e/* require.ensure */(144).then((function () {
    return r(__webpack_require__(259));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 驾考新规
var zhongjiaRule = function zhongjiaRule(r) {
  return __webpack_require__.e/* require.ensure */(139).then((function () {
    return r(__webpack_require__(273));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 2017新交规扣分标准
var zhongjiaNewRule = function zhongjiaNewRule(r) {
  return __webpack_require__.e/* require.ensure */(138).then((function () {
    return r(__webpack_require__(274));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 酒驾新规
var zhongjiaDrunkDriving = function zhongjiaDrunkDriving(r) {
  return __webpack_require__.e/* require.ensure */(140).then((function () {
    return r(__webpack_require__(272));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 我想了解
var zhongjiaWantKnow = function zhongjiaWantKnow(r) {
  return __webpack_require__.e/* require.ensure */(88).then((function () {
    return r(__webpack_require__(275));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 在线报名
var zhongjiaOnlineApply = function zhongjiaOnlineApply(r) {
  return __webpack_require__.e/* require.ensure */(66).then((function () {
    return r(__webpack_require__(266));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 支付成功后查询页
var zhongjiaPayResult = function zhongjiaPayResult(r) {
  return __webpack_require__.e/* require.ensure */(65).then((function () {
    return r(__webpack_require__(267));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 我要注册
var zhongjiaReferrer = function zhongjiaReferrer(r) {
  return __webpack_require__.e/* require.ensure */(64).then((function () {
    return r(__webpack_require__(271));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
// 我的推荐
var zhongjiaRecommend = function zhongjiaRecommend(r) {
  return __webpack_require__.e/* require.ensure */(89).then((function () {
    return r(__webpack_require__(270));
  }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
/** 中驾微信公众号 end */

var constRouterMap = [
// 一些驾校报名入口
{ path: '/someDrivingSchoolApply', name: 'someDrivingSchoolApply', component: someDrivingSchoolApply },
// 云之驾App
{ path: '/platformHomeApp', name: 'platformHomeApp', component: platformHomeApp }, { path: '/platformHomeDetailsApp', name: 'platformHomeDetailsApp', component: platformHomeDetailsApp }, { path: '/platformBodyCheckApp', name: 'platformBodyCheckApp', component: platformBodyCheckApp }, { path: '/platformRuleApp', name: 'platformRuleApp', component: platformRuleApp }, { path: '/platformOnlineApplyApp', name: 'platformOnlineApplyApp', component: platformOnlineApplyApp }, { path: '/platformResultPayZFBApp', name: 'platformResultPayZFBApp', component: platformResultPayZFBApp }, { path: '/platformWantKnowApp', name: 'platformWantKnowApp', component: platformWantKnowApp }, { path: '/platformRecruitStudentApp', name: 'platformRecruitStudentApp', component: platformRecruitStudentApp }, { path: '/platformBannerApp', name: 'platformBannerApp', component: platformBannerApp }, { path: '/platformWarningCoachApp', name: 'platformWarningCoachApp', component: platformWarningCoachApp },

// 车小爱App
{ path: '/loveUpCoachApp', name: 'loveUpCoachApp', component: loveUpCoachApp }, { path: '/loveRegisterApp', name: 'loveRegisterApp', component: loveRegisterApp }, { path: '/loveRegisterProtocolApp', name: 'loveRegisterProtocolApp', component: loveRegisterProtocolApp }, { path: '/loveMyLoveCoinApp', name: 'loveMyLoveCoinApp', component: loveMyLoveCoinApp }, { path: '/loveMyLoveCoinHistoryApp', name: 'loveMyLoveCoinHistoryApp', component: loveMyLoveCoinHistoryApp }, { path: '/loveMyLoveCoinRuleApp', name: 'loveMyLoveCoinRuleApp', component: loveMyLoveCoinRuleApp },
// 游客首页
{ path: '/loveHomeApp', name: 'loveHomeApp', component: loveHomeApp }, { path: '/loveHomeDetailsApp', name: 'loveHomeDetailsApp', component: loveHomeDetailsApp }, { path: '/loveBodyCheckApp', name: 'loveBodyCheckApp', component: loveBodyCheckApp }, { path: '/loveRuleApp', name: 'loveRuleApp', component: loveRuleApp }, { path: '/loveOnlineApplyApp', name: 'loveOnlineApplyApp', component: loveOnlineApplyApp }, { path: '/loveApplyPayApp', name: 'loveApplyPayApp', component: loveApplyPayApp }, { path: '/loveResultPayZFBApp', name: 'loveResultPayZFBApp', component: loveResultPayZFBApp }, { path: '/loveWantKnowApp', name: 'loveWantKnowApp', component: loveWantKnowApp },
// 更多
{ path: '/loveMorePageApp', name: 'loveMorePageApp', component: loveMorePageApp }, { path: '/loveTeachAreaApp', name: 'loveTeachAreaApp', component: loveTeachAreaApp }, { path: '/loveMyTrainApp', name: 'loveMyTrainApp', component: loveMyTrainApp },
// 车小爱
{ path: '/loveRecruitStudent', name: 'loveRecruitStudent', component: loveRecruitStudent }, { path: '/loveBannerApp', name: 'loveBannerApp', component: loveBannerApp }, { path: '/loveProductList', name: 'loveProductList', component: loveProductList }, { path: '/loveProductDetails', name: 'loveProductDetails', component: loveProductDetails },
// 练车技巧
{ path: '/lovePracticeSkills', name: 'lovePracticeSkills', component: lovePracticeSkills },
// 推广查询
{ path: '/lovePromotionQuery', name: 'lovePromotionQuery', component: lovePromotionQuery }, { path: '/lovePromotionRegister', name: 'lovePromotionRegister', component: lovePromotionRegister },
// 报名指南
{ path: '/loveGuide', name: 'loveGuide', component: loveGuide }, { path: '/loveBodyCheck', name: 'loveBodyCheck', component: loveBodyCheck }, { path: '/loveBodyQuery', name: 'loveBodyQuery', component: loveBodyQuery }, { path: '/loveHealthList', name: 'loveHealthList', component: loveHealthList }, { path: '/loveHealthAddress', name: 'loveHealthAddress', component: loveHealthAddress }, { path: '/loveRule', name: 'loveRule', component: loveRule }, { path: '/loveNewRule', name: 'loveNewRule', component: loveNewRule }, { path: '/loveDrunkDriving', name: 'loveDrunkDriving', component: loveDrunkDriving }, { path: '/loveWantKnow', name: 'loveWantKnow', component: loveWantKnow },
// 报名
{ path: '/loveOnlineApply', name: 'loveOnlineApply', component: loveOnlineApply }, { path: '/loveResultPayOfficial', name: 'loveResultPayOfficial', component: loveResultPayOfficial }, { path: '/loveApplyQuery', name: 'loveApplyQuery', component: loveApplyQuery }, { path: '/loveNotice', name: 'loveNotice', component: loveNotice }, { path: '/loveNotice/loveNoticePapers', name: 'loveNoticePapers', component: loveNoticePapers }, { path: '/loveNotice/loveNoticeFlow', name: 'loveNoticeFlow', component: loveNoticeFlow }, { path: '/loveAbout', name: 'loveAbout', component: loveAbout }, { path: '/loveAbout/loveAboutUs', name: 'loveAboutUs', component: loveAboutUs }, { path: '/loveAbout/loveAboutAddress', name: 'loveAboutAddress', component: loveAboutAddress }, { path: '/loveActivity', name: 'loveActivity', component: loveActivity }, { path: '/loveDownLoadApp', name: 'loveDownLoadApp', component: loveDownLoadApp }, { path: '/loveSmallSchool', name: 'loveSmallSchool', component: loveSmallSchool }, { path: '/loveSmallSchool/lovePhoto', name: 'lovePhoto', component: lovePhoto }, { path: '/loveSmallSchool/lovePhoto/lovePhotoDetail', name: 'lovePhotoDetail', component: lovePhotoDetail }, { path: '/loveSmallSchool/loveSchoolAddress', name: 'loveSchoolAddress', component: loveSchoolAddress }, { path: '/loveSmallSchool/loveSchoolAddress/loveSchoolAddressDetail', name: 'loveSchoolAddressDetail', component: loveSchoolAddressDetail }, { path: '/loveMy', name: 'loveMy', component: loveMy }, { path: '/loveAerialPhoto', name: 'loveAerialPhoto', component: loveAerialPhoto }, { path: '/loveAerialPhotoDetail', name: 'loveAerialPhotoDetail', component: loveAerialPhotoDetail }, { path: '/loveNewActive', name: 'loveNewActive', component: loveNewActive },
// 车小爱题库
{ path: '/loveQuestionBank/questionCont/exercise', name: 'loveExercise', component: loveExercise }, { path: '/loveQuestionBank/questionCont/simulate', name: 'loveSimulate', component: loveSimulate }, { path: '/loveStudyScope', name: 'loveStudyScope', component: loveStudyScope }, { path: '/loveStudyScope/newRule/studyRule1', name: 'loveStudyRule1', component: loveStudyRule1 }, { path: '/loveStudyScope/newRule/studyRule2', name: 'loveStudyRule2', component: loveStudyRule2 }, { path: '/loveStudyScope/newRule/studyRule3', name: 'loveStudyRule3', component: loveStudyRule3 }, { path: '/loveStudyScope/newRule/studyRule4', name: 'loveStudyRule4', component: loveStudyRule4 }, { path: '/loveStudyScope/answer', name: 'loveAnswer', component: loveAnswer }, { path: '/loveStudyScope/answer/answerTip/answerTip1', name: 'loveAnswerTip1', component: loveAnswerTip1 }, { path: '/loveStudyScope/answer/answerTip/answerTip2', name: 'loveAnswerTip2', component: loveAnswerTip2 }, { path: '/loveStudyScope/answer/answerTip/answerTip3', name: 'loveAnswerTip3', component: loveAnswerTip3 }, { path: '/loveStudyScope/answer/answerTip/answerTip4', name: 'loveAnswerTip4', component: loveAnswerTip4 }, { path: '/loveStudyScope/answer/answerTip/answerTip5', name: 'loveAnswerTip5', component: loveAnswerTip5 }, { path: '/loveStudyScope/answer/answerTip/answerTip6', name: 'loveAnswerTip6', component: loveAnswerTip6 }, { path: '/loveStudyScope/answer/answerTip/answerTip7', name: 'loveAnswerTip7', component: loveAnswerTip7 }, { path: '/loveStudyScope/answer/answerTip/answerTip8', name: 'loveAnswerTip8', component: loveAnswerTip8 }, { path: '/loveStudyScope/experience/experience2', name: 'loveExperience2', component: loveExperience2 }, { path: '/loveStudyScope/experience/experience2/experience2Tip/experience2Tip1', name: 'loveExperience2Tip1', component: loveExperience2Tip1 }, { path: '/loveStudyScope/experience/experience2/experience2Tip/experience2Tip2', name: 'loveExperience2Tip2', component: loveExperience2Tip2 }, { path: '/loveStudyScope/experience/experience2/experience2Tip/experience2Tip3', name: 'loveExperience2Tip3', component: loveExperience2Tip3 }, { path: '/loveStudyScope/experience/experience2/experience2Tip/experience2Tip4', name: 'loveExperience2Tip4', component: loveExperience2Tip4 }, { path: '/loveStudyScope/experience/experience2/experience2Tip/experience2Tip5', name: 'loveExperience2Tip5', component: loveExperience2Tip5 }, { path: '/loveStudyScope/experience/experience2/experience2Tip/experience2Tip6', name: 'loveExperience2Tip6', component: loveExperience2Tip6 }, { path: '/loveStudyScope/experience/experience2/experience2Tip/experience2Tip7', name: 'loveExperience2Tip7', component: loveExperience2Tip7 }, { path: '/loveStudyScope/experience/experience2/experience2Tip/experience2Tip8', name: 'loveExperience2Tip8', component: loveExperience2Tip8 }, { path: '/loveStudyScope/experience/experience2/experience2Tip/experience2Tip9', name: 'loveExperience2Tip9', component: loveExperience2Tip9 }, { path: '/loveStudyScope/experience/experience3', name: 'loveExperience3', component: loveExperience3 }, { path: '/loveStudyScope/experience/experience3/experience3Tip/experience3Tip1', name: 'loveExperience3Tip1', component: loveExperience3Tip1 }, { path: '/loveStudyScope/experience/experience3/experience3Tip/experience3Tip2', name: 'loveExperience3Tip2', component: loveExperience3Tip2 }, { path: '/loveStudyScope/experience/experience3/experience3Tip/experience3Tip3', name: 'loveExperience3Tip3', component: loveExperience3Tip3 }, { path: '/loveStudyScope/beforeExam', name: 'loveBeforeExam', component: loveBeforeExam },
// 消息提醒
{ path: '/messageApp/m0001', name: 'm0001', meta: { keepAlive: false }, component: m0001 },
// 荣安App
{ path: '/guidePicApp', name: 'guidePicApp', component: guidePicApp }, { path: '/ronganInfo', name: 'schoolInfoApp', component: schoolInfoApp }, { path: '/homeApp', name: 'homeApp', component: homeApp }, { path: '/homeDetailsApp', name: 'homeDetailsApp', component: homeDetailsApp }, { path: '/bodyCheckApp', name: 'bodyCheckApp', component: bodyCheckApp }, { path: '/ruleApp', name: 'ruleApp', component: ruleApp }, { path: '/onlineApplyApp', name: 'onlineApplyApp', component: onlineApplyApp }, { path: '/resultPayZFBApp', name: 'resultPayZFBApp', component: resultPayZFBApp }, { path: '/wantKnowApp', name: 'wantKnowApp', component: wantKnowApp }, { path: '/applyQueryApp', name: 'applyQueryApp', component: applyQueryApp }, { path: '/theoryOrder', name: 'theoryOrder', component: theoryOrder }, { path: '/busOrder', name: 'busOrder', component: busOrder }, { path: '/examinationMessageApp', name: 'examinationMessageApp', component: examinationMessageApp }, { path: '/complaintApp', name: 'complaintApp', component: complaintApp }, { path: '/feedBackApp', name: 'feedBackApp', component: feedBackApp }, { path: '/bannerApp', name: 'bannerApp', component: bannerApp }, { path: '/allProcessShareApp', name: 'allProcessShareApp', component: allProcessShareApp },
// 荣安教练app

{ path: '/recruitStudent', name: 'recruitStudent', component: recruitStudent }, { path: '/studentDetailApp', name: 'studentDetailApp', component: studentDetailApp }, { path: '/studentListApp', name: 'studentListApp', meta: { keepAlive: false }, component: studentListApp }, { path: '/studentListApp/feeList', name: 'feeList', component: feeList }, { path: '/myPerformanceApp', name: 'myPerformanceApp', component: myPerformanceApp }, { path: '/myPerformChooseModelApp', name: 'myPerformChooseModelApp', component: myPerformChooseModelApp }, { path: '/orderTrainApp', name: 'orderTrainApp', component: orderTrainApp }, { path: '/orderTrainChooseDateApp', name: 'orderTrainChooseDateApp', component: orderTrainChooseDateApp }, { path: '/orderCoachChoose', name: 'orderCoachChoose', component: orderCoachChoose }, { path: '/facilityFaultApp', name: 'facilityFaultApp', component: facilityFaultApp }, { path: '/studentAssessApp', name: 'studentAssessApp', component: studentAssessApp }, { path: '/competentAssessApp', name: 'competentAssessApp', component: competentAssessApp }, { path: '/shareStudentApp', name: 'shareStudentApp', component: shareStudentApp },
// 荣安公众号
{ path: '/', redirect: '/home' }, { path: '/home', name: 'home', component: home }, { path: '/home/homeDetails', name: 'homeDetails', component: homeDetails }, { path: '/bannerDetail', name: 'bannerDetail', component: bannerDetail }, { path: '/questionBank', name: 'questionBank', component: questionBank }, { path: '/questionBank/questionCont/exercise', name: 'exercise', component: exercise }, { path: '/questionBank/questionCont/simulate', name: 'simulate', component: simulate }, { path: '/ucenter', name: 'ucenter', component: ucenter }, { path: '/apply_query', name: 'apply_query', component: applyQuery }, { path: '/personal_details', name: 'personal_details', component: personalDetails }, { path: '/market/stutentSign/:orgCode', name: 'stutentSign', component: stutentSign }, { path: '/guide', name: 'guide', component: guide }, { path: '/onlineApply', name: 'onlineApply', component: onlineApply }, { path: '/onlineApply/applyDetails', name: 'applyDetails', component: applyDetails }, { path: '/resultPayOfficial', name: 'resultPayOfficial', component: resultPayOfficial }, { path: '/wantKnow', name: 'wantKnow', component: wantKnow }, { path: '/promotionQuery', name: 'promotionQuery', component: promotionQuery },
// 由于字数限制缩短路径名
{ path: '/pR', name: 'promotionRegister', component: promotionRegister }, { path: '/coachRegister', name: 'coachRegister', component: coachRegister }, { path: '/smallSchool', name: 'smallSchool', component: smallSchool }, { path: '/myRecommend', name: 'myRecommend', component: myRecommend }, { path: '/bodyCheck', name: 'bodyCheck', component: bodyCheck }, { path: '/bodyQuery', name: 'bodyQuery', component: bodyQuery }, { path: '/healthList', name: 'healthList', component: healthList }, { path: '/healthAddress', name: 'healthAddress', component: healthAddress }, { path: '/rule', name: 'rule', component: rule }, { path: '/newRule', name: 'newRule', component: newRule }, { path: '/drunkDriving', name: 'drunkDriving', component: drunkDriving }, { path: '/studyScope', name: 'studyScope', component: studyScope }, { path: '/studyScope/newRule/studyRule1', name: 'studyRule1', component: studyRule1 }, { path: '/studyScope/newRule/studyRule2', name: 'studyRule2', component: studyRule2 }, { path: '/studyScope/newRule/studyRule3', name: 'studyRule3', component: studyRule3 }, { path: '/studyScope/newRule/studyRule4', name: 'studyRule4', component: studyRule4 }, { path: '/studyScope/answer', name: 'answer', component: answer }, { path: '/studyScope/answer/answerTip/answerTip1', name: 'answerTip1', component: answerTip1 }, { path: '/studyScope/answer/answerTip/answerTip2', name: 'answerTip2', component: answerTip2 }, { path: '/studyScope/answer/answerTip/answerTip3', name: 'answerTip3', component: answerTip3 }, { path: '/studyScope/answer/answerTip/answerTip4', name: 'answerTip4', component: answerTip4 }, { path: '/studyScope/answer/answerTip/answerTip5', name: 'answerTip5', component: answerTip5 }, { path: '/studyScope/answer/answerTip/answerTip6', name: 'answerTip6', component: answerTip6 }, { path: '/studyScope/answer/answerTip/answerTip7', name: 'answerTip7', component: answerTip7 }, { path: '/studyScope/answer/answerTip/answerTip8', name: 'answerTip8', component: answerTip8 }, { path: '/studyScope/experience/experience2', name: 'experience2', component: experience2 }, { path: '/studyScope/experience/experience2/experience2Tip/experience2Tip1', name: 'experience2Tip1', component: experience2Tip1 }, { path: '/studyScope/experience/experience2/experience2Tip/experience2Tip2', name: 'experience2Tip2', component: experience2Tip2 }, { path: '/studyScope/experience/experience2/experience2Tip/experience2Tip3', name: 'experience2Tip3', component: experience2Tip3 }, { path: '/studyScope/experience/experience2/experience2Tip/experience2Tip4', name: 'experience2Tip4', component: experience2Tip4 }, { path: '/studyScope/experience/experience2/experience2Tip/experience2Tip5', name: 'experience2Tip5', component: experience2Tip5 }, { path: '/studyScope/experience/experience2/experience2Tip/experience2Tip6', name: 'experience2Tip6', component: experience2Tip6 }, { path: '/studyScope/experience/experience2/experience2Tip/experience2Tip7', name: 'experience2Tip7', component: experience2Tip7 }, { path: '/studyScope/experience/experience2/experience2Tip/experience2Tip8', name: 'experience2Tip8', component: experience2Tip8 }, { path: '/studyScope/experience/experience2/experience2Tip/experience2Tip9', name: 'experience2Tip9', component: experience2Tip9 }, { path: '/studyScope/experience/experience3', name: 'experience3', component: experience3 }, { path: '/studyScope/experience/experience3/experience3Tip/experience3Tip1', name: 'experience3Tip1', component: experience3Tip1 }, { path: '/studyScope/experience/experience3/experience3Tip/experience3Tip2', name: 'experience3Tip2', component: experience3Tip2 }, { path: '/studyScope/experience/experience3/experience3Tip/experience3Tip3', name: 'experience3Tip3', component: experience3Tip3 }, { path: '/studyScope/beforeExam', name: 'beforeExam', component: beforeExam }, { path: '/teachingJournal/subject2/training2Log', name: 'training2Log', component: training2Log }, { path: '/teachingJournal/subject2/inspection2Log', name: 'inspection2Log', component: inspection2Log }, { path: '/teachingJournal/subject3/training3Log', name: 'training3Log', component: training3Log }, { path: '/teachingJournal/subject3/inspection3Log', name: 'inspection3Log', component: inspection3Log }, { path: '/teachingJournal/subject3/sameCarInteractionLog', name: 'sameCarInteractionLog', component: sameCarInteractionLog }, { path: '*', redirect: '/404' }, { path: '/404', name: '404', component: notFound },

// 视频播放
{ path: '/video/part', name: 'videoParts', component: videoParts }, { path: '/video/lesson', name: 'videoLessons', component: videoLessons }, { path: '/video/play', name: 'videoPlay', component: videoPlay },
// 微信-考场
{ path: '/exam', name: 'exam', component: exam }, { path: '/exam/coach/identify', name: 'coachIdentify', component: coachIdentify }, { path: '/exam/coach/main', name: 'coachMain', component: coachMain }, { path: '/exam/coach/vehicel/register', name: 'vehicelRegister', component: vehicelRegister }, { path: '/exam/coach/vehicel/list', name: 'vehicelList', component: vehicelList }, { path: '/exam/student/identify', name: 'studentIdentify', component: studentIdentify }, { path: '/exam/student/main', name: 'studentMain', component: studentMain }, { path: '/exam/manager/identify', name: 'managerIdentify', component: managerIdentify }, { path: '/exam/manager/main', name: 'managerMain', component: managerMain }, { path: '/exam/manager/recordList', name: 'recordList', component: recordList }, { path: '/exam/manager/workList', name: 'workList', component: workList }, { path: '/exam/manager/vehicelConfirm', name: 'vehicelConfirm', component: vehicelConfirm }, { path: '/exam/manager/overTimeOrder', name: 'overTimeOrder', component: overTimeOrder }, { path: '/exam/booking/modelSelection', name: 'modelSelection', component: modelSelection }, { path: '/exam/booking/lessionSelection', name: 'lessionSelection', component: lessionSelection }, { path: '/exam/booking/timeSelection', name: 'timeSelection', component: timeSelection }, { path: '/exam/booking/turnsSelection', name: 'turnsSelection', component: turnsSelection },
//  { path: '/exam/booking/selectionConfirm'，name: 'selectionConfirm', component: selectionConfirm},
{ path: '/exam/booking/bookingResult', name: 'bookingResult', component: bookingResult }, { path: '/exam/booking/bookingList', name: 'bookingList', component: bookingList },
//  { path: '/exam/booking/payConfirm', name: 'payConfirm', component: payConfirm },
{ path: '/exam/account/center', name: 'accountCenter', component: accountCenter }, { path: '/exam/account/detail', name: 'accountDetail', component: accountDetail }, { path: '/exam/order/orderList', name: 'orderList', component: orderList },
//  { path: '/exam/order/orderConfirm', name: 'orderConfirm', component: orderConfirm },
{ path: '/personRecharge', name: 'personRecharge', component: personRecharge }, { path: '/vehicleRecharge', name: 'vehicleRecharge', component: vehicleRecharge }, { path: '/rechargeResult', name: 'rechargingResult', component: rechargingResult }, { path: '/selectionConfirm', name: 'selectionConfirm', component: selectionConfirm }, { path: '/orderConfirm', name: 'orderConfirm', component: orderConfirm }, { path: '/orderPayResult', name: 'orderPayResult', component: orderPayResult },
/** 中驾公众号 start */
{ path: '/zhongjiaProduct', name: 'zhongjiaProduct', component: zhongjiaProduct }, { path: '/zhongjiaGuide', name: 'zhongjiaGuide', component: zhongjiaGuide }, { path: '/zhongjiaBodyCheck', name: 'zhongjiaBodyCheck', component: zhongjiaBodyCheck }, { path: '/zhongjiaBodyQuery', name: 'zhongjiaBodyQuery', component: zhongjiaBodyQuery }, { path: '/zhongjiaHealthList', name: 'zhongjiaHealthList', component: zhongjiaHealthList }, { path: '/zhongjiaRule', name: 'zhongjiaRule', component: zhongjiaRule }, { path: '/zhongjiaNewRule', name: 'zhongjiaNewRule', component: zhongjiaNewRule }, { path: '/zhongjiaDrunkDriving', name: 'zhongjiaDrunkDriving', component: zhongjiaDrunkDriving }, { path: '/zhongjiaWantKnow', name: 'zhongjiaWantKnow', component: zhongjiaWantKnow }, { path: '/zhongjiaOnlineApply', name: 'zhongjiaOnlineApply', component: zhongjiaOnlineApply }, { path: '/zhongjiaPayResult', name: 'zhongjiaPayResult', component: zhongjiaPayResult }, { path: '/aboutZhongJia', name: 'aboutZhongJia', component: aboutZhongJia }, { path: '/partMenu', name: 'partMenu', component: partMenu }, { path: '/zhongjiaExamPart1', name: 'zhongjiaExamPart1', component: zhongjiaExamPart1 }, { path: '/zhongjiaExamPart2', name: 'zhongjiaExamPart2', component: zhongjiaExamPart2 }, { path: '/zhongjiaExamPart3', name: 'zhongjiaExamPart3', component: zhongjiaExamPart3 }, { path: '/zhongjiaExamPart4', name: 'zhongjiaExamPart4', component: zhongjiaExamPart4 }, { path: '/zhongjiaReferrer', name: 'zhongjiaReferrer', component: zhongjiaReferrer }, { path: '/zhongjiaRecommend', name: 'zhongjiaRecommend', component: zhongjiaRecommend }];

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  // mode: 'history',
  saveScrollPosition: true,
  routes: constRouterMap,
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    if (from.meta.keepAlive) {
      from.meta.savedPosition = document.body.scrollTop;
    }
    return { x: 0, y: to.meta.savedPosition || 0 };
  }
});

router.beforeEach(function (to, from, next) {
  __WEBPACK_IMPORTED_MODULE_2_vue_ydui_dist_lib_rem_dialog__["Loading"].open('\0');
  next();
});

router.afterEach(function () {
  setTimeout(function () {
    __WEBPACK_IMPORTED_MODULE_2_vue_ydui_dist_lib_rem_dialog__["Loading"].close();
  }, 200);
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 4 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 5 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(19)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(13),
  /* template */
  __webpack_require__(29),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fastclick__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fastclick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fastclick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_ydui__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_ydui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_ydui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_ydui_dist_ydui_rem_css__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_ydui_dist_ydui_rem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_ydui_dist_ydui_rem_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_ydui_dist_ydui_base_css__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_ydui_dist_ydui_base_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_ydui_dist_ydui_base_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_main_scss__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__styles_main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(3);











if ('addEventListener' in document) {
  document.addEventListener('DOMContentLoaded', function () {
    __WEBPACK_IMPORTED_MODULE_1_fastclick___default.a.attach(document.body);
  }, false);
}

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_ydui___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_6__App___default.a);
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppAddress',
  props: {
    src: {
      type: String,
      default: 'http://static.ydcss.com/uploads/ydui/1.jpg'
    },
    //    part2，part3是否-不展示
    isActive: {
      type: Boolean,
      default: false
    },
    //      part1背景是否为灰色
    bgActive: {
      type: Boolean,
      default: true
    }

  },
  data: function data() {
    return {};
  },
  created: function created() {
    if (this.isWeiXin) {
      // this.showHeader = false;
      document.title = this.title;
      var iframe = document.createElement('iframe');
      iframe.src = './favicon.ico';
      iframe.style.display = 'none';
      iframe.onload = function () {
        setTimeout(function () {
          document.body.removeChild(iframe);
        }, 0);
      };
      document.body.appendChild(iframe);
    }
  },

  methods: {
    isWeiXin: function isWeiXin() {
      var ua = window.navigator.userAgent.toLowerCase();
      var res = ua.match(/MicroMessenger/i);
      return res === 'micromessenger';
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'AppLayout',
  props: {
    fontsize: {
      type: String,
      default: '.34rem'
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    showBack: {
      type: Boolean,
      default: true
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ''
    },
    bgcolor: {
      type: String,
      default: '#19b4e7'
    },
    color: {
      type: String,
      default: '#fff'
    },
    height: {
      type: String,
      default: '1rem'
    },
    fixed: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {};
  },
  created: function created() {
    if (this.isWeiXin) {
      // this.showHeader = false;
      document.title = this.title;
      var iframe = document.createElement('iframe');
      iframe.src = './favicon.ico';
      iframe.style.display = 'none';
      iframe.onload = function () {
        setTimeout(function () {
          document.body.removeChild(iframe);
        }, 0);
      };
      document.body.appendChild(iframe);
    }
  },

  methods: {
    goBack: function goBack() {
      this.$router.go(-2);
      return false;
    },
    isWeiXin: function isWeiXin() {
      var ua = window.navigator.userAgent.toLowerCase();
      var res = ua.match(/MicroMessenger/i);
      return res === 'micromessenger';
    }
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IndexApply',
  props: {
    src: {
      type: String,
      default: 'http://static.ydcss.com/uploads/ydui/1.jpg'
    },
    bgcolor: {
      type: String,
      default: '19b4e7'
    }
  },
  data: function data() {
    return {};
  },
  created: function created() {},

  methods: {}
});

/***/ }),
/* 17 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/banner_201903282.65bb3fa.jpg";

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(18)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(14),
  /* template */
  __webpack_require__(28),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7766f4d0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(17)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(27),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3eb605c8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(20)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(16),
  /* template */
  __webpack_require__(30),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-be417cfe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('yd-layout', [(_vm.showHeader) ? _c('yd-navbar', {
    staticStyle: {
      "top": "-1px"
    },
    attrs: {
      "title": _vm.title,
      "fontsize": _vm.fontsize,
      "bgcolor": _vm.bgcolor,
      "color": _vm.color,
      "height": _vm.height,
      "fixed": _vm.fixed
    }
  }, [_c('div', {
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }, [_vm._t("header-left")], 2), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_vm._t("header-right")], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "main-container"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.showFooter) ? _c('yd-tabbar', {
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "fixed": "",
      "fontsize": "0.28rem"
    }
  }, [_vm._t("tabbar", function() {
    return [_c('yd-tabbar-item', {
      attrs: {
        "title": "首页",
        "link": "/home"
      }
    }, [_c('yd-icon', {
      attrs: {
        "slot": "icon",
        "name": "home",
        "size": "0.5rem"
      },
      slot: "icon"
    })], 1), _vm._v(" "), _c('yd-tabbar-item', {
      attrs: {
        "title": "其他",
        "link": "/shopcart"
      }
    }, [_c('yd-icon', {
      attrs: {
        "slot": "icon",
        "name": "shopcart-outline",
        "size": "0.5rem"
      },
      slot: "icon"
    })], 1), _vm._v(" "), _c('yd-tabbar-item', {
      attrs: {
        "title": "个人中心",
        "link": "/ucenter"
      }
    }, [_c('yd-icon', {
      attrs: {
        "slot": "icon",
        "name": "ucenter-outline",
        "size": "0.5rem"
      },
      slot: "icon"
    }), _vm._v(" "), _c('yd-badge', {
      attrs: {
        "slot": "badge",
        "type": "danger"
      },
      slot: "badge"
    }, [_vm._v("2")])], 1)]
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('yd-flexbox', {
    staticClass: "part1",
    class: {
      part1_bg: _vm.bgActive
    }
  }, [_vm._t("part1_img", null, {
    "src": _vm.src
  }), _vm._v(" "), _c('yd-flexbox-item', {
    staticStyle: {
      "padding-left": "0.15rem"
    }
  }, [_vm._t("part1_title"), _vm._v(" "), _vm._t("part1_address"), _vm._v(" "), _vm._t("part1_style")], 2), _vm._v(" "), _vm._t("part1_tell")], 2), _vm._v(" "), _c('div', {
    staticClass: "part2",
    class: {
      unActive: _vm.isActive
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "5rem"
    }
  }, [_vm._t("part2_title"), _vm._v(" "), _vm._t("part2_carStyle"), _vm._v(" "), _vm._t("part2_style"), _vm._v(" "), _vm._t("part2_priceTip"), _vm._v(" "), _vm._t("part2_price")], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "1.15rem",
      "float": "right"
    }
  }, [_vm._t("part2_apply")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "part3",
    class: {
      unActive: _vm.isActive
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "5rem"
    }
  }, [_vm._t("part3_title"), _vm._v(" "), _vm._t("part3_carStyle"), _vm._v(" "), _vm._t("part3_style"), _vm._v(" "), _vm._t("part3_priceTip"), _vm._v(" "), _vm._t("part3_price")], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "1.15rem",
      "float": "right"
    }
  }, [_vm._t("part3_apply")], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('transition', {
    attrs: {
      "name": "router-fade",
      "mode": "out-in"
    }
  }, [_c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "router-fade",
      "mode": "out-in"
    }
  }, [(!_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('yd-slider', {
    staticClass: "borderTop",
    staticStyle: {
      "height": "4.17rem"
    },
    attrs: {
      "autoplay": "5000"
    }
  }, [_c('yd-slider-item', [_c('a', {
    attrs: {
      "href": "http://wxc76ce18c45894494.dodoca.com/authorize/redirect?param=bDhCY1c0bkNtNWlEU1RLZkx3eWVmdmNXcWk5ak9aNjlXcVNXcHFOZG9nUmF0c0s2SXplWTh0ZjVqdk5iZ3orMmlrR09VWCs4N1JPTlNPMXQ=&uid=a3NaWEN0YkR4cDdLWDM3ZWUwWQ=="
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(23)
    }
  })])])], 1)
},staticRenderFns: []}

/***/ })
],[12]);


// WEBPACK FOOTER //
// static/js/app.c2d95131b253cf02acb7.js